import React from 'react';

import Facebook from '-!svg-react-loader!../../ui/svgs/facebook.svg';
import Instagram from '-!svg-react-loader!../../ui/svgs/instagram.svg';
import Linkedin from '-!svg-react-loader!../../ui/svgs/linkedin.svg';
import Spotify from '-!svg-react-loader!../../ui/svgs/spotify.svg';
import Twitter from '-!svg-react-loader!../../ui/svgs/twitter.svg';
import Youtube from '-!svg-react-loader!../../ui/svgs/youtube.svg';
import { Container } from './styles';

interface IProps {
  className?: string;
  data?: any;
}

const socialIcons = {
  facebook: <Facebook />,
  instagram: <Instagram />,
  linkedin: <Linkedin />,
  spotify: <Spotify />,
  twitter: <Twitter />,
  youtube: <Youtube />
};

const Social = ({ data }: IProps) => {
  return (
    <Container data-gtm-action="externa" data-gtm-category="navegacion">
      {data &&
        data.map(value => (
          <li className="item" key={value.id}>
            <a
              data-gtm-event
              data-gtm-label={value.url}
              href={value.url}
              data-testid={value.id}
              className={`icon ${value.title.toLowerCase()}`}
              rel="noreferrer noopener"
              aria-label={`This icon is a link to our ${value.title.toLowerCase()} (will be opened in a new window)`}>
              {socialIcons[value.title.toLowerCase()]}
            </a>
          </li>
        ))}
    </Container>
  );
};

export default Social;
